import { OrderedMap } from 'immutable';
import * as ActionTypes from '../../actions/ActionTypes';
import MultiLangCategories from '../../records/edit/MultiLangCategoriesRecord';
import CategoryTranslationRecord from 'knowledge-content-ui/records/CategoryTranslationRecord';
const updateCategoryFromTranslationSuccess = (state, response) => {
  const {
    categories
  } = response;
  const category = CategoryTranslationRecord.fromJS(categories[0]);
  return state.setIn(
  // small fix of a type mismatch
  ['categories', category.knowledgeCategoryId], category);
};
export function transformCategoryToMap({
  categories = []
}) {
  return categories.reduce((acc, category) => acc.concat([[category.id || category.knowledgeCategoryId, CategoryTranslationRecord.fromJS(category)], ...Object.values(category.nameTranslations).filter(({
    id
  }) => !!id && category.id !== id).map(categoryTranslation => [categoryTranslation.id, CategoryTranslationRecord.fromJS(categoryTranslation)])]), OrderedMap());
}
export default ((state = new MultiLangCategories(), action) => {
  switch (action.type) {
    case ActionTypes.FETCH_MULTI_LANGUAGE_CATEGORIES_ERROR:
      return state.merge({
        error: action.error,
        isLoading: false,
        isRequesting: false
      });
    case ActionTypes.FETCH_MULTI_LANGUAGE_CATEGORIES_PENDING:
      return state.merge({
        error: undefined,
        isLoading: true,
        isRequesting: true
      });
    case ActionTypes.FETCH_MULTI_LANGUAGE_CATEGORIES_SUCCESS:
      return state.merge({
        error: undefined,
        isRequesting: false,
        isLoading: false,
        lastLoaded: new Date().valueOf(),
        categories: transformCategoryToMap(action.payload.response),
        primaryLanguage: action.payload.response.primaryLanguage,
        lastLoadedOptions: action.payload.options
      });
    case ActionTypes.CREATE_MULTI_LANGUAGE_CATEGORY_ERROR:
      return state.merge({
        error: action.error,
        isCreating: false
      });
    case ActionTypes.CREATE_MULTI_LANGUAGE_CATEGORY_PENDING:
      return state.merge({
        error: undefined,
        isCreating: true
      });
    case ActionTypes.CREATE_MULTI_LANGUAGE_CATEGORY_SUCCESS:
      return state.merge({
        error: undefined,
        isCreating: false
      });
    case ActionTypes.CLEAR_CREATE_MULTI_LANGUAGE_CATEGORY_ERROR:
      return state.merge({
        error: null
      });
    case ActionTypes.UPDATE_CATEGORY_TRANSLATIONS_SUCCESS:
      return updateCategoryFromTranslationSuccess(state, action.payload);
    case ActionTypes.UPDATE_CATEGORY_TRANSLATIONS_ERROR:
      return state.set('error', action.error);
    default:
      return state;
  }
});